const serverPath = 'https://momentibles-upload-service.herokuapp.com/';

export default serverPath;
